<section class="body-sign">
    <div class="center-sign">
        <a href="/" class="logo w-100 text-center d-block">
            <img src="assets/img/logo.png" height="44" alt="Comply365" />
        </a>

        <div class="panel card-sign">

            <h3 class="title text-center text-uppercase font-weight-light my-4">Recover Password</h3>

            <div class="card-body">
                <error-message [errors]="errors"></error-message>
                <div class="alert alert-info" *ngIf="!submitAttempt">
                    <p class="m-none text-weight-semibold h6">Enter your e-mail below and we will send you reset instructions!</p>
                </div>
                <div class="alert alert-success" *ngIf="submitAttempt">
                    <p class="m-none text-weight-semibold h6">Thank you. If the email entered matches our records you will receive a reset link.</p>
                </div>

                <form #recoverPasswordForm="ngForm" (submit)="recoverpassword()">
                    <div class="form-group mb-none">
                        <div class="input-group">
                            <input name="username" type="email" placeholder="E-mail" class="form-control input-lg" required [(ngModel)]="email" #vemail="ngModel" />
                            <span class="input-group-btn">
                                <button class="btn btn-primary btn-lg" type="submit">Reset!</button>
                            </span>
                        </div>
                        <div *ngIf="vemail.errors && (vemail.dirty || vemail.touched || submitAttempt)">
                            <label class="error" [hidden]="!vemail.errors.required">Email is a required field.</label>
                        </div>
                    </div>

                    <p class="text-center mt-lg">
                        Remembered? <a [routerLink]="['/auth/login']">Sign In!</a>
                    </p>
                </form>

            </div>
        </div>

        <p class="text-center text-muted mt-3 mb-3">&copy; Copyright 2020. All Rights Reserved.</p>
    </div>
</section>
